/*
// Javascript to enable link to tab
var hash = document.location.hash;
var prefix = "tab_";
if (hash) {
  $('#enxoval .btn-link[data-target="'+hash.replace(prefix,"")+'"]').click();
} 

// Change hash for page-reload
$('#enxoval .btn-link').on('shown', function (e) {
  window.location.hash = e.target.hash.replace("#", "#" + prefix);
});

*/

/*
$('[change-tab-enxoval]').each(function( index ) {
  $(this).click(function(){
    setTimeout(
      function() 
      {
        // Javascript to enable link to tab
        var hash = document.location.hash;

        var prefix = "tab_";
        $('#enxoval [data-target="'+hash.replace(prefix,"")+'"]').click();

        //$('html, body').animate({scrollTop: $('#enxoval .btn-link[data-target="'+hash.replace(prefix,"")+'"]').offset().top -100 }, 'slow');
		$('html, body').animate({scrollTop: $('#enxoval').offset().top -100 }, 'slow');
        
        // Change hash for page-reload
        $('#enxoval .btn-link').on('shown', function (e) {
          window.location.hash = e.target.hash.replace("#", "#" + prefix);
        });
        
        var targetTab = $(hash.replace(prefix,""));
        
        console.log(targetTab);
        
        $(targetTab).parent().addClass('destaque-aba');
        
        setTimeout(
          function() 
          {
            $(targetTab).parent().removeClass('destaque-aba');
          }, 6000);
      }, 500);
    
  });
  
});

$('[change-tab-estampa]').each(function( index ) {
  $(this).click(function(){
    setTimeout(
      function() 
      {
        // Javascript to enable link to tab
        var hash = document.location.hash;

        var prefix = "tab_";
        $('#estampa [data-target="'+hash.replace(prefix,"")+'"]').click();

        //$('html, body').animate({scrollTop: $('#estampa .btn-link[data-target="'+hash.replace(prefix,"")+'"]').offset().top -100 }, 'slow');
		$('html, body').animate({scrollTop: $('#estampa').offset().top -100 }, 'slow');
        
        // Change hash for page-reload
        $('#estampa .btn-link').on('shown', function (e) {
          window.location.hash = e.target.hash.replace("#", "#" + prefix);
        });
        
        var targetTab = $(hash.replace(prefix,""));
        
        console.log(targetTab);
        
        $(targetTab).parent().addClass('destaque-aba');
        
        setTimeout(
          function() 
          {
            $(targetTab).parent().removeClass('destaque-aba');
          }, 6000);
      }, 500);
    
  });
  
});

$('[check-options]').click(function(event){
  event.preventDefault();
 
  var total = $('[check-parametros]').length;
  
  $('[check-parametros]').each(function( index ) {
    if($(this).val() == undefined || $(this).val() == "" || $(this).val() == null){
      
      $('html, body').animate({scrollTop: $(this).offset().top -100 }, 'slow');
      $(this).closest(".btn-link").click();
      $(this).click();

      $('#enxoval [data-target="'+hash.replace(prefix,"")+'"]').click();
      
      setTimeout(
        function() 
        {
          $(this).closest(".card").removeClass('destaque-aba');
        }, 6000);
      
      return false;
    }
    
    if (index === total - 1) {
      function addPrimary(){
        var params = {
          url: window.router + '/cart/add.js',
          data: $('.product-form-product-template').serialize(),
          dataType: 'json'
        };

        $.post(params)
        .done(
          function(item) {
            $('[data-cart-pc]').click();
          }.bind(this)
        )
        .fail(
          function(response) {
            console.log("Erro ao adicionar");
          }.bind(this)
        );
      }

      var itens = [];

      $('[personalize-item-product]').each(function( index ) {

        var idVariant = parseInt($(this).val());  

        itens.push({
          quantidade: 1,
          id: idVariant
        });

      });

      const data = {
        items: itens
      };

      var params = {
        url: '/cart/add.js',
        data: data,
        dataType: 'json'
      };

      $.post(params)
      .done(
        function(item) {
          //$('[data-cart-pc]').click();
          console.log("produtos adicionados");
          addPrimary()
        }.bind(this)
      )
      .fail(
        function(response) {
          console.log("Erro ao adicionar");
        }.bind(this)
      );
    }
  });


  return;
});
*/

$(document).ready(function() {
  $(function() { 
    $.cookieBar({
      style: 'bottom',
      infoLink: '/pages/politica-de-privacidade'
    });
  });
  
  var d = new Date();
  var strDate = d.getFullYear() + "/" + (d.getMonth()+1) + "/" + d.getDate();
  
  var datesArray = window.datasContador;

  // Today's date
  var today = new Date();

  // Set a flag to be used when found
  var found = false;
  // For each calendar date, check if it is within a range.
  for (i = 0; i < datesArray.length; i++) {
    // Get each from/to ranges
    var From = datesArray[i].from.split("/");
    var To = datesArray[i].to.split("/");
    // Format them as dates : Year, Month (zero-based), Date
    var FromDate = new Date(From[2], From[1] - 1, From[0]);
    var ToDate = new Date(To[2], To[1] - 1, To[0]);
    var schedule = datesArray[i].schedule;
    
    // Compare date
    if (today >= FromDate && today <= ToDate) {
      found = true;
      var dataLimit = To[2]+"/"+To[1]+"/"+To[0];
      var mensagem = datesArray[i].mensagem;
      
      dataLimit = dataLimit.toString();
      
      headerCountdown(dataLimit,mensagem);
      break;
    }

  }

  //At the end of the for loop, if the date wasn't found, return true.
  if (!found) {
    console.log("Not found");
    $('.header-top-bf').addClass('hide');
    $('body').removeClass('countdown-campaing');
  }

  function headerCountdown(data,mensagem){
    $('.header-top-bf').countdown(data, function(event) {
      var totalHours = event.offset.totalDays * 24 + event.offset.hours;

      $('.diasCount').html(event.strftime('%D'));
      $('.horasCount').html(event.strftime('%H'));
      $('.minutosCount').html(event.strftime('%M'));
      $('.seguntosCount').html(event.strftime('%S'));

    });
    
    $('.mensagem-contador').html(mensagem);
    $('.header-top-bf').attr('style',  'background-color:'+window.corContador);
    $('.header-top-bf').removeClass('hide');
    $('body').addClass('countdown-campaing');
  }

  const targetButton = document.querySelector(".btn.btn--secondary.btn--large");
  console.log(targetButton)
  if (!targetButton) {
    console.error("Botão de rolagem infinita não encontrado.");
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        console.log("Botão visível, clicando automaticamente...");
        targetButton.click();
      }
    });
  });

  observer.observe(targetButton);
});